import { IconsProps } from '@/types/shared'
import React from 'react'

const ContractNewIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                viewBox="0 0 21 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 0C15 1.93296 13.433 3.49991 11.5 3.49991V5.49991C13.433 5.49991 15 7.06692 15 8.9999L16.0001 9H17C17 7.06702 18.567 5.49991 20.5 5.49991L20.5001 3.49991C18.5672 3.49991 17.0001 1.93296 17 0H15ZM9.5 3.5582C9.172 3.51976 8.8383 3.5 8.5 3.5C3.80558 3.5 0 7.30558 0 12C0 16.6944 3.80558 20.5 8.5 20.5C13.1944 20.5 17 16.6944 17 12C17 11.6617 16.9802 11.3279 16.9418 10.9999L14.9235 11C14.9739 11.3259 15 11.6599 15 12C15 15.5899 12.0899 18.5 8.5 18.5C4.91015 18.5 2 15.5899 2 12C2 8.41015 4.91015 5.5 8.5 5.5C8.8401 5.5 9.174 5.52611 9.5 5.57645V3.5582ZM7.5 13V16H9.5V13H12.5V11H9.5V8H7.5V11H4.5V13H7.5Z"
                    fill="currentColor"
                />
            </svg>
        </div>
    )
}

export default ContractNewIcons
